import type { CSSProperties } from 'react'

interface AudioOrbProps {
  size?: number
  seed?: number
  playing?: boolean
}

/**
 * 圆形音频缩略图（中性灰渐变环 + 波形 glyph）
 * 播放时外圈带脉冲扩散环（voice-pulse-ring 关键帧）
 */
export const AudioOrb = ({ size = 48, seed = 1, playing = false }: AudioOrbProps) => {
  const angle = (seed * 47) % 360
  return (
    <div
      className="relative shrink-0 w-[var(--orb-s)] h-[var(--orb-s)]"
      style={{ '--orb-s': `${size}px` } as CSSProperties}
    >
      {playing && (
        <div className="absolute -inset-[3px] rounded-full border border-white/[0.20] animate-[voice-pulse-ring_1.6s_ease-out_infinite]" />
      )}
      <div
        className="relative flex h-full w-full items-center justify-center rounded-full shadow-[inset_0_0_0_1px_rgba(255,255,255,0.10)] bg-[image:var(--orb-bg)]"
        style={
          {
            '--orb-bg': `conic-gradient(from ${angle}deg, rgba(255,255,255,0.04), rgba(255,255,255,0.20), rgba(255,255,255,0.04))`,
          } as CSSProperties
        }
      >
        <div className="absolute inset-[3px] rounded-full bg-[#1a1a1a] bg-[radial-gradient(circle_at_30%_30%,rgba(255,255,255,0.06),transparent_60%)]" />
        <svg
          className="relative text-white/[0.85]"
          fill="none"
          height={size * 0.46}
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.8"
          viewBox="0 0 24 24"
          width={size * 0.46}
        >
          <path d="M4 12h2M8 8v8M12 5v14M16 9v6M20 11v2" />
        </svg>
      </div>
    </div>
  )
}
